import axios from 'axios'
import { useCallback } from 'react'

export const useUnsubscribe = () => {
  return {
    getEmail: useCallback(async (token: string) => {
      const { data } = await axios.get('/crm/v1/consent/unsubscribe', {
        params: {
          token,
        },
      })

      return data.email
    }, []),
    unsubscribeEmail: useCallback(async (email: string, token: string) => {
      await axios.post('/crm/v1/consent/unsubscribe', {
        token,
        email,
      })
    }, []),
  }
}
